import { render, staticRenderFns } from "./KnowledgeAdvancedFilter.vue?vue&type=template&id=0635f11d&"
import script from "./KnowledgeAdvancedFilter.vue?vue&type=script&lang=js&"
export * from "./KnowledgeAdvancedFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports